export { PostItemInfo } from './PostItemInfo.component';
export type { PostItemInfoProps } from './PostItemInfo.props';
